export default __webpack_public_path__ + "static/media/IMG_0172.6027ba9f.gif";